export default __webpack_public_path__ + "static/media/annexTable11.d82c8807.png";